import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react'
import { addDays, format } from 'date-fns'
import React, { useCallback, useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import CustomDatePicker from '../../../../components/CustomDatePicker/CustomDatePicker'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from './../../../../utils/hooks/Context/RequestStatusContext'
import Selector from '../../../../components/Selector/Selector'
import useButtonSelector from '../../../../utils/hooks/useButtonSelector/useButtonSelector'

const options = [
  {
    id: 0,
    value: 'excel',
    label: 'Excel',
  },
  {
    id: 1,
    value: 'pdf',
    label: 'PDF',
  },
]

export default function PurchaseOrders() {
  const { selected, onSelectedChange } = useButtonSelector(options)
  const [filterData, setFilterData] = useState({})
  const [nnData, setNNData] = useState(null)

  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const handleGetPurchaseOrders = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .OCReport(filterData.dDesde || null, filterData.dHasta || null)
      .then((res) => {
        const newOdatos = res.data.oDatos.map((item) => ({
          ...item,
          FechaEmision: format(new Date(item.FechaEmision), 'dd-MM-yyyy'),
        }))
        handleCLoseLoading()
        setNNData({ ...res.data, oDatos: newOdatos })
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle(error.response.data.error, error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  const handleChangeFrom = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dDesde: date ? format(date, 'dd-MM-yyyy') : null,
    }))
  }, [])

  const handleChangeTo = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dHasta: date ? format(date, 'dd-MM-yyyy') : null,
    }))
  }, [])

  const handleGetReport = async () => {
    if (!selected) return

    const extension = selected.value === 'pdf' ? 'pdf' : 'xlsx'

    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .OCExport(
        filterData.dDesde || null,
        filterData.dHasta || null,
        selected.value,
      )
      .then((res) => {
        const url = URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `Resumen_de_ordenes_de_compra.${extension}`,
        )
        document.body.appendChild(link)
        link.click()
        handleSetTitle('Reporte descargado con exito', 200)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            Continuar
          </Button>,
        )
        handleOpen()
        handleCLoseLoading()
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle('No se pudo exportar el reporte.', error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  return (
    <VStack alignItems="flex-start">
      <HStack alignItems="flex-end">
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="subtitle2">Desde</Text>
          <Box border="1px solid #D7D7D7" maxW="150px" minW="150px">
            <CustomDatePicker
              onChange={handleChangeFrom}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="subtitle2">Hasta</Text>
          <Box border="1px solid #D7D7D7" maxW="150px" minW="150px">
            <CustomDatePicker
              maxDate={addDays(new Date(), 15)}
              placeholder="dd/mm/aaaa"
              onChange={handleChangeTo}
            />
          </Box>
        </VStack>
        <VStack paddingStart={5}>
          <Button borderRadius={10} onClick={handleGetPurchaseOrders}>
            Buscar
          </Button>
        </VStack>
      </HStack>
      {nnData ? (
        <HStack alignItems="flex-end" paddingTop={5}>
          <VStack alignItems="flex-start">
            <Text variant="body2" fontWeight="bold">
              Descargar en formato
            </Text>
            <Box w="200px">
              <Selector
                isClearable
                options={options}
                onChange={onSelectedChange}
              />
            </Box>
          </VStack>
          <VStack paddingStart={5}>
            <Button onClick={handleGetReport}>Descargar informe</Button>
          </VStack>
        </HStack>
      ) : null}
    </VStack>
  )
}
